<div class="w-full mb-6">
   <button class="download_professional_report mb-5">
    <div class="flex align-items-center">
      BAIXAR RELATÓRIO
    <split-icon class="ml-2" name="arrow-bar-to-down"></split-icon>
    </div>
  </button> 



  
     <div class="gradient">
      
     </div>
    <split-report-table  [data]="data" [widthColumns]="['10', '15', '15', '10', '15', '10', '15', '10']" >
      <ng-template #header> Data </ng-template>
      <ng-template #column let-row="row">
        <div class="primary_font_style text-sm">

          {{ row?.data_emissao }}
        </div>
      </ng-template>
  
      <ng-template #header> Paciente </ng-template>
      <ng-template #column let-row="row">
        <div class="add_ellipsis">
          {{ row?.nome_paciente }}
        </div>
      </ng-template>

      <ng-template #header> CPF </ng-template>
      <ng-template #column let-row="row"> 000.000.000-00 </ng-template>

      <ng-template #header> Unidade </ng-template>
      <ng-template #column let-row="row"> Unidade x </ng-template>
  
      <ng-template #header> Serviço </ng-template>
      <ng-template #column let-row="row">
        <div class="px-3 add_ellipsis">
          {{ row?.nome_servico }}
        </div>
      </ng-template>
  
      <ng-template #header> Convênio </ng-template>
      <ng-template #column let-row="row">{{ row?.convenio }}</ng-template>

      <ng-template #header> Forma de Pagamento </ng-template>
      <ng-template #column let-row="row"> forma de pagamento x </ng-template>
  
      <ng-template #header> Valor total da nota </ng-template>
      <ng-template #column let-row="row">
        R${{ row?.valor_total_servico }}</ng-template
      >
  
      <!-- <ng-template #header> Centro </ng-template>
      <ng-template #column let-row="row">{{ row?.valor_centro }}</ng-template>
  
      <ng-template #header> Especialista </ng-template>
      <ng-template #column let-row="row">
        R${{ row?.valor_especialista }}
      </ng-template> -->
    </split-report-table>
  
  
</div>
